import Button from '@/features/shared/Button';
import { makeStyles } from '@material-ui/core/styles';
import { prop } from 'lodash/fp';
import React from 'react';

interface CardDownloadButtonProps {
  labels: any;
}

const useCardDownloadButtonStyles = makeStyles({
  root: {
    '& .download-button': {
      minWidth: '100px',
    },
  },
});

const CardDownloadButton = ({ labels }: CardDownloadButtonProps) => {
  const classes = useCardDownloadButtonStyles();

  return (
    <div className={classes.root}>
      <Button className="download-button" size="small">
        {prop('download_button_label', labels)}
      </Button>
    </div>
  );
};

export default CardDownloadButton;
